import React from "react";
import { Link } from "react-router-dom";
import Icon from "feather-icons-react";
import "./qt-icons.scss";

export function QtIcon({ name, size = 20, strokeWidth = 2, className = "", ariaHidden = true }) {
  if (!name) return null;
  return (
    <Icon
      icon={name}
      size={size}
      strokeWidth={strokeWidth}
      className={`qt-icon ${className}`.trim()}
      aria-hidden={ariaHidden}
    />
  );
}

export function QtCheck({ size = 14, className = "" }) {
  return <QtIcon name="check" size={size} strokeWidth={3} className={`qt-icon--check ${className}`.trim()} />;
}

export function QtChevronRight({ size = 18, className = "" }) {
  return <QtIcon name="chevron-right" size={size} className={className} />;
}

export function QtChevronLeft({ size = 20, className = "" }) {
  return <QtIcon name="chevron-left" size={size} className={className} />;
}

export function QtMenu({ size = 22, className = "" }) {
  return <QtIcon name="menu" size={size} className={className} />;
}

export function QtClose({ size = 22, className = "" }) {
  return <QtIcon name="x" size={size} className={className} />;
}

export function QtBackLink({ to, children, className = "" }) {
  return (
    <Link to={to} className={`qt-back-link ${className}`.trim()}>
      <QtChevronLeft size={18} />
      <span>{children}</span>
    </Link>
  );
}
